export default __webpack_public_path__ + "static/assets/med_x_spray_oral_mask.03fec1dc.png";